<div class="row">
    <app-cybersocxmenu></app-cybersocxmenu>
</div>
<div class="col-12">
    <div class="row">
        <div class="col-lg-6 col-sm-12">
            <app-incidentform (searchEmitter)="search()" (searchEmitterSingleCase)="searchCase($event)" handlePdfExport="false" handleAdvSearch="true" #incidentForm> </app-incidentform>
        </div>
        <div class="col-lg-6 col-sm-12 position-relative">
          <app-filtermenu [items]="filterMenuItems">
            <app-pie
            class="card"
            [data]="groupedIncidents"
            title="Incidents by type"
            suffix=""
            innerSize= 0
            ></app-pie>
          </app-filtermenu>
            <select class="form-select form-control" name="groupBy" aria-describedby="groupBy" [(ngModel)]="groupBy" id="groupBy" (change)="updateGroupBy($event.target.value)">
                <option value="severities">Severities</option>
                <option value="owner">Owners</option>
                <option value="incident_status">Status (Open/Close)</option>
                <option value="xdr_status">Status</option>
                <option value="categories">Categories</option> 
            </select>
        </div>
    </div>

    <div class="app-incident">
        <div class="col-12">
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ active: page === 'cases' }" (click)="page = 'cases'; loadCases();">All <span class="badge bg-primary ms-2" style="padding:0.1rem 0.5rem;">{{ casesCountPrettier }}</span></a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ active: page === 'flagged' }" (click)="page = 'flagged'; loadCases();"
                        >{{ 'pages.generic.flagged' | translate }} <span class="badge bg-primary ms-2" style="padding:0.1rem 0.5rem;">{{ flags.length }}</span>
                    </a>
                </li>
            </ul>
            <div class="tools">
                <ng-template #exportIncidentsTooltip> {{ 'pages.cybersocxdr.dashboard.exportIncidents' | translate }}</ng-template>
                <fa-icon [icon]="['fas', 'file-csv']" size="2x" class="p-1 click" (click)="exportCases();"
                [ngbTooltip]="exportIncidentsTooltip"></fa-icon>
            </div>
        </div>

        <div *ngIf="(page === 'cases' || page === 'flagged')">
            <section class="rowfiller"
            infiniteScroll
            [infiniteScrollDistance]="2"
            [infiniteScrollThrottle]="60"
            (scrolled)="loadNextCases()">

                <h3 class="p-4 px-5" *ngIf="title">{{ title }}</h3>
                <h5 class="px-5 subtitle" *ngIf="subtitle">{{ subtitle }}</h5>
                <div class="card-body p-t-1 px-3">
                    <app-microsoccase-list class="app-incident" [cases]="cases" [loaded]="casesLoaded" [scrollLoading]="scrollLoading" [flags]="flags" (newFlagEmitter)="onFlag($event)" (sortEmitter)="sortCases($event)"></app-microsoccase-list>
                </div>
            </section>

        </div>
    </div>
</div>
